<div class="mat-typography" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>{{isAcquisition() ? 'Confirm Receipt' : (isDisposal() ? 'Confirm Disposal' : firearmAssetTypeName + ' Assignment Handover')}}</h2>
  <mat-dialog-content class="dialog-content">
    <div class="spinner-container" *ngIf="busy$ | async">
      <mat-spinner></mat-spinner>
    </div>
    <div>
      <form [formGroup]="form">
        <div class="crud-item-section" *ngIf="isModerator()">
          <span class="crud-editor-info">Police notification is not required for moderators.</span>
        </div>
        <div class="crud-item-section" *ngIf="isPoolFirearmIssue() && !isModerator()">
          <span class="crud-editor-info">This {{firearmTypeName}} is a Pool {{firearmTypeName}}.<br/>
            Police notification is not mandatory.</span>
        </div>
        <div class="crud-item-section" *ngIf="isPersonalFirearmIssue() && !isModerator()">
          <span class="crud-editor-info">Police notification is not required for personal firearm issue.</span>
        </div>
        <div class="crud-item-section" *ngIf="isAcquisition() && !isModerator()">
          <span class="crud-editor-warning">Police notification is required for acquisition.</span>
        </div>
        <div class="crud-item-section" *ngIf="isAcquisition() && item.acquisitionDocumentsPresent === false">
          <span class="crud-editor-info">No acquisition document has been uploaded. You can continue, but please upload the purchase order or receipt when available.</span>
        </div>
        <div class="crud-item-section" *ngIf="isTransfer() && !isModerator()">
          <span class="crud-editor-info">Police notification is optional for transfer.</span>
        </div>
        <div class="crud-item-section" *ngIf="isDisposal() && !isModerator()">
          <span class="crud-editor-warning">Police notification is required for disposal.</span>
        </div>
        <div class="crud-item-section" *ngIf="isIssue() && !isPoolFirearmIssue() && !isPersonalFirearmIssue() && !isModerator()">
          <span class="crud-editor-info">Police notification is optional for ranger issue.</span>
        </div>
        <div class="crud-item-section" *ngIf="isPoliceNotificationAvailable()">
          <span>
            <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="notifyPolice"
              id="notifyPolice" (ngModelChange)="notifyPoliceChanging($event)" [(ngModel)]="item.notifyPolice"
              (ngModelChange)="notifyPoliceChanged($event)" #notifyPolice i18n="@@type.FirearmAssignment.notifyPolice">
              Notify Police </mat-slide-toggle>
          </span>
        </div>
        <div class="crud-item-section" *ngIf="isConfirmationLocationRequired()">
          <mat-form-field class="crud-item-input-wide">
            <mat-label>{{isAcquisition() ? 'Storage Location' : (isDisposal() ? 'Disposal Location' : 'Location')}}</mat-label>
            <mat-select formControlName="location" [(ngModel)]="item.location" [compareWith]="locationCompare">
              <mat-option *ngFor="let location of locationSelectionList" [value]="location">{{locationDisplay(location)}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="crud-item-section" *ngIf="isAcquisition()">
          <mat-form-field class="crud-item-input-wide">
            <mat-label>Gun Dealer</mat-label>
            <mat-select formControlName="gunDealerLocation" [(ngModel)]="item.gunDealerLocation" [compareWith]="locationCompare">
              <mat-option *ngFor="let location of gunDealerLocationSelectionList" [value]="location">{{locationDisplay(location)}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="crud-item-section" *ngIf="isPoliceNotificationAvailable()">
          <mat-form-field matTooltip="Police Notification Reason" class="crud-item-input-verywide">
            <mat-label i18n="@@type.FirearmAssignment.policeNotificationReason">Police Notification Reason / Comments</mat-label>
            <textarea matInput formControlName="policeNotificationReason" id="policeNotificationReason"
              [(ngModel)]="policeNotificationReasonText" maxlength="1000" placeholder="Police Notification Reason / Comments">
          </textarea>
          </mat-form-field>
        </div>
      </form>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" [disabled]="!isActivateEnabled()"
      (click)="activateFirearmAssignment()">{{isAcquisition() ? 'Confirm Receipt' : (isDisposal() ? 'Confirm Disposal' : 'Handover')}}</button>
    <button mat-raised-button color="accent" [disabled]="busy" (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
  <div class="crud-editor-error-list" *ngIf="getFormErrorList().length > 0">
    <br>
    <h2>Errors:</h2>
    <div *ngFor="let error of getFormErrorList()" class="crud-editor-err-msg">{{error}}</div>
  </div>
</div>
